import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syssa } from '../entity/Syssa-angular';

export interface SyssaData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number; }


@Injectable({
  providedIn: 'root'
})
export class SyssaServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Syssa(); 
    this.entityType.type = EntityType.master;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
         }; 

    this.fieldNames = '' ;
    this.fieldLengths = {} ;
    this.columnDefs = [
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSSA' ;
    this.isSys =false; 
    this.sqlSelect = `SELECT SYSSA.*  FROM SYSSA` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY SA001,SA002,SA003,SA004` ;
    this.keyFields = ['SA001','SA002','SA003','SA004'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = [];
    this.seqField = '' ;
    this.seqFieldLength = 0 ;
  }
  override async validateItem(item: Syssa): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Syssa): Promise<Syssa> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

